import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-link';
export var ID = 'icon-link';
/* eslint-disable max-len */

export var SVGLink = function SVGLink() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 16 16"
  }, React.createElement("defs", null, React.createElement("path", {
    d: "M16,8.57607837 C15.9997127,10.5502308 14.3991754,12.1507681 12.4250326,12.1510554 L9.29597837,12.1513427 C7.32125133,12.1511511 5.72011069,10.5500392 5.72016815,8.57556121 C5.72078109,8.21847628 5.77344597,7.87300847 5.87064471,7.54780596 L6.70447176,7.54726006 C6.95907135,7.54726964 7.19979361,7.6398426 7.38786057,7.80824762 C7.29064268,8.04897946 7.23969212,8.3082144 7.24026675,8.57500573 C7.24022844,9.12476424 7.45378026,9.6403035 7.8426614,10.0291368 C8.23090087,10.4173954 8.74711054,10.631541 9.296553,10.6312537 L12.4247453,10.6312537 C12.9736131,10.631541 13.489727,10.4173954 13.8780814,10.029041 C14.2669146,9.64020773 14.4804856,9.12466847 14.4801983,8.57581979 C14.4804856,8.02638691 14.2664358,7.51021555 13.8780814,7.12189946 C13.4898228,6.73361211 12.9736131,6.51950481 12.4241706,6.5198017 L10.8256446,6.51952397 C10.6063273,6.08150235 10.3158516,5.6776042 9.95881456,5.32057674 C9.84542082,5.20715427 9.72733427,5.09953557 9.60350141,5 L12.4244579,5.00055548 C14.3988881,5.00053632 15.9997127,6.60139923 16,8.57607837 Z M6.05799338,11.8473632 L6.0585297,11.8480336 C6.16559293,11.9551064 6.2770425,12.0560498 6.39185366,12.1512469 L3.57494827,12.1512469 C1.6005277,12.1513427 -4.78858688e-05,10.5507096 2.57571742e-14,8.57630823 C1.91543476e-05,6.60075755 1.60054686,5.00022985 3.57556121,5.00074702 L6.70439514,5.00016281 C8.67882529,5.00014366 10.2799372,6.60127472 10.2799372,8.57567613 C10.2796499,8.93302922 10.2272627,9.27876519 10.1294798,9.60458064 L9.29674454,9.60515527 C9.04218326,9.60515527 8.80055117,9.51283132 8.61255125,9.34331534 C8.70937647,9.10225788 8.76003972,8.84271647 8.76003972,8.57537924 C8.75975241,8.02654972 8.5462772,7.51095299 8.15734818,7.12209101 C7.76910871,6.73381323 7.25351198,6.52028056 6.70435684,6.51970593 L3.57611668,6.51970593 C3.0264348,6.51966762 2.51024428,6.73379408 2.12193777,7.12209101 C1.73364084,7.51039752 1.51957185,8.02653057 1.52012733,8.57569529 C1.52012733,9.12543464 1.73365999,9.6409739 2.12193777,10.0293283 C2.51022513,10.4175869 3.02635818,10.6317325 3.5755229,10.6310621 L5.1854075,10.6310621 C5.40757878,11.0811893 5.70037213,11.4897515 6.05799338,11.8473632 Z",
    id: "path"
  })), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("rect", {
    x: "0",
    y: "0",
    width: "16",
    height: "16"
  }), React.createElement("mask", {
    id: "mask",
    fill: "white"
  }, React.createElement("use", {
    xlinkHref: "#path-1"
  })), React.createElement("use", {
    fill: "#6D6565",
    fillRule: "nonzero",
    xlinkHref: "#path"
  }), React.createElement("g", {
    mask: "url(#mask)",
    fill: "#6D6565"
  }, React.createElement("rect", {
    x: "0",
    y: "0",
    width: "16",
    height: "16"
  }))));
};
/* eslint-disable max-len */

var Link = function Link(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGLink
  });
};

Link.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Link;